module.exports = __webpack_public_path__ + "images/motoshare_small9e5b8cf6a4f7625a897810ae0bf27bb5.png";